import { gql } from "@apollo/client/core";

export default gql`
    mutation DeleteDisasterDamage($id: ID!) {
        deleteDamage(input: { id: $id }) {
            errors
            status
            statusCode
        }
    }
`